import { newFirestoreId } from 'common/utils/newRentalUtils';
import { DbRefs } from 'common/db/api/types';
import { getOrderObject } from './getOrderObject';

export const createApiHelperQueries = (dbRef: DbRefs) => ({
	getOrderObject: getOrderObject(dbRef),
	newFirestoreId,
});
